import request from '../request';

const itemIsRevocable = (item) => {
  if (typeof item.has_withdrawal_right === 'undefined' || item.has_withdrawal_right === null) {
    return true;
  }
  return String(item.has_withdrawal_right) === '1';
};

const itemIsRevoked = (item) => {
  if (typeof item.revoked === 'undefined' || item.revoked === null) {
    return false;
  }
  return item.revoked === true || String(item.revoked) === '1';
};

const itemSubmitId = (item) => (item.itemId != null ? item.itemId : item.barcode);

const itemUid = (item, index) => {
  const ref = itemSubmitId(item);
  return `${index}-${ref != null ? ref : 'item'}`;
};

const normalizeOrder = (order) => {
  if (!order || !Array.isArray(order.items)) {
    return order || {};
  }
  return {
    ...order,
    items: order.items.map((item, index) => ({
      ...item,
      revocable: itemIsRevocable(item),
      revoked: itemIsRevoked(item),
      uid: itemUid(item, index),
    })),
  };
};

export default {
  namespaced: true,
  state: {
    loading: false,
    order: {},
    status: 'available',
    identification: { orderNumber: '', email: '', orderDate: '' },
    selectedUids: [],
    message: '',
    receipt: {},
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setOrder(state, order) {
      state.order = order;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setIdentification(state, identification) {
      state.identification = identification;
    },
    setSelectedUids(state, uids) {
      state.selectedUids = uids;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setReceipt(state, receipt) {
      state.receipt = receipt;
    },
  },
  actions: {
    getOrder(context, { orderNumber, email, orderDate }) {
      return new Promise((resolve, reject) => {
        const { app } = context.rootState;
        context.commit('setLoading', true);
        context.commit('setIdentification', { orderNumber, email, orderDate });
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.ORDER_REVOKE}?id=${encodeURIComponent(
          orderNumber
        )}&email=${encodeURIComponent(email)}&date=${encodeURIComponent(orderDate)}`;
        request.make({ type: 'GET', url }, (err, res) => {
          context.commit('setLoading', false);
          if (res && res.status === 200 && typeof res.body !== 'undefined') {
            context.commit('setOrder', normalizeOrder(res.body.data));
            context.commit('setStatus', 'available');
            context.commit('setSelectedUids', []);
            resolve(res.body.data);
          } else {
            context.commit('setOrder', {});
            context.commit('setStatus', 'notAvailable');
            reject(res);
          }
        });
      });
    },
    submitRevocation(context) {
      return new Promise((resolve, reject) => {
        const { app } = context.rootState;
        const { identification, selectedUids, message } = context.state;
        context.commit('setLoading', true);
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.ORDER_REVOKE}`;
        const items = (context.state.order.items || [])
          .filter((item) => selectedUids.includes(item.uid))
          .map((item) => itemSubmitId(item));
        const data = {
          id: identification.orderNumber,
          email: identification.email,
          date: identification.orderDate,
          items,
          message,
        };
        request.make({ type: 'POST', url, data }, (err, res) => {
          context.commit('setLoading', false);
          if (res && res.status === 200) {
            context.commit('setReceipt', (res.body && res.body.data) || {});
            resolve(res.body && res.body.data);
          } else {
            reject(res);
          }
        });
      });
    },
  },
};
